import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CameraServerService } from '../camera-server.service';
import { ToastrService } from 'ngx-toastr';
import { SpinnerService } from 'src/app/components/spinner-component/spinner.service';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { Ec2AddEditComponent } from '../dialogs/ec2-add-edit/ec2-add-edit.component';
import { ConfirmationDialogueComponent } from 'src/app/components/confirmation-dialogue/confirmation-dialogue.component';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { AppConstants } from 'src/app/shared/app-constants';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-get-all-ec2',
  templateUrl: './get-all-ec2.component.html',
  styleUrls: ['./get-all-ec2.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule
  ]
})
export class GetAllEc2Component implements OnInit {
  userForm: any;
  isEditDevice: boolean = false;
  newdata: any = '';
  totalRecords = 0;
  pageSize = 10;
  pageIndex = 0;
  editCameraConfig = false;

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private ngbModalService: NgbModal,
    private camService: CameraServerService,
    private toastr: ToastrService,
    public spinner: SpinnerService,
    private _location: Location,
    public dialog: MatDialog,
    private authService: AuthenticationService
  ) {
    this.userForm = this.fb.group({
      id: [''],
      nodeName: [''],
      instanceId: [''],
      privateIp: [''],
    });
  }
  displayedColumns: string[] = [
    'id',
    'nodeName',
    'instanceId',
    'privateIp',
    'publicIp',
    'action',
  ];

  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  ngOnInit(): void {
    this.getAllEc2List();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.pageIndex = this.paginator.pageIndex;
    this.pageSize = this.paginator.pageSize;
    this.sort.active
    this.dataSource.sort = this.sort;
    this.sort.direction
    this.sort?.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
  }

  getAllEc2List() {
    this.spinner.activate();
    this.getCurrentUser();
    this.camService.getAllEc2().subscribe(
      (res: any) => {
        if (res && res.success) {
          this.newdata = res.data;
          this.spinner.deactivate();
          this.dataSource = new MatTableDataSource<any>(res.data);
          this.dataSource.paginator = this.paginator;
          this.totalRecords = res?.data?.length || []?.length;
          this.dataSource.sort = this.sort;
        } else {
          this.spinner.deactivate();
          this.toastr.error(AppConstants.defaultErrorMessage);
        }

      },
      (error: any) => {
        if (error) {
          this.spinner.deactivate();
          this.toastr.error(AppConstants.defaultErrorMessage);
        }
      }
    );
  }

  getCurrentUser() {
    const currentUser = this.authService.currentUserValue;
    if (currentUser) {
      if (currentUser['privileges'] && currentUser['privileges'].length > 0) {
        for (let i = 0; i < currentUser['privileges'].length; i++) {
          if (currentUser['privileges'][i].toLowerCase() === 'edit camera configuration') {
            this.editCameraConfig = true;
          }
        }
      }
    }
  }

  changePaging(event: any) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
  }

  deleteFarmById(elementData: any) {

    let popupData = {};
    popupData = {
      title: "Delete Confirmation",
      message: `Are you sure you want to delete  ${elementData?.nodeName}`,
      cancelBtnText: "No",
      confirmBtnText: "Yes"
    }

    let dialoge = this.ngbModalService.open(ConfirmationDialogueComponent);
    dialoge.componentInstance._data = popupData;
    dialoge.result.then(data => {
      if (data) {
        this.spinner.activate();
        this.camService.deleteAllEc2(elementData.nodeName).subscribe((data) => {
          if (data && data?.success) {
            this.toastr.success('Deleted successfully!');
            this.spinner.deactivate();
            this.getAllEc2List();
          } else {
            this.toastr.error(data?.messages[0] || AppConstants.defaultErrorMessage);
            this.spinner.deactivate();
          }
        }, (err) => {
          if (err) {
            this.spinner.deactivate();
            this.toastr.error(AppConstants.defaultErrorMessage);
          }
        });
      }
    })
  }

  addFarmData() {
    const dialogRef = this.dialog.open(Ec2AddEditComponent, {
      width: '100%',
      data: { isEdit: false },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe((result) => {
      dialogRef.close();
      this.getAllEc2List();
    });

  }

  deleteFarmConfirmation() {
    const dialogRef = this.dialog.open(Ec2AddEditComponent, {
      width: '100%',
      data: { isEdit: false },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe((result) => {
      dialogRef.close();
      this.getAllEc2List();
    });

  }

  updateFarmById(getRecord: any) {
    const record = { edidatbleData: getRecord, isEdit: true };
    const dialogRef = this.dialog.open(Ec2AddEditComponent, {
      width: '100%',
      data: record,
      disableClose: true
    });
    dialogRef.afterClosed().subscribe((result) => {
      dialogRef.close();
      this.getAllEc2List();
    });
  }

}
